'use client';

import type { AnchorHTMLAttributes, MouseEvent } from 'react';
import { isCredentialBearingPath, sanitizeAnalyticsPathname } from '../../lib/analyticsPrivacy';
import { cookieManager } from '../../lib/cookieManager';
import { usePostHogContext } from '../posthog-provider';

type StorePlatform = 'auto' | 'ios' | 'android';

interface StoreDownloadLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  platform?: StorePlatform;
  placement: string;
}

const downloadPaths: Record<StorePlatform, string> = {
  auto: '/api/download',
  ios: '/api/download/ios',
  android: '/api/download/android',
};

export function StoreDownloadLink({
  platform = 'auto',
  placement,
  onClick,
  children,
  ...anchorProps
}: StoreDownloadLinkProps) {
  const { isInitialized } = usePostHogContext();

  function handleClick(event: MouseEvent<HTMLAnchorElement>) {
    onClick?.(event);

    const pathname = window.location.pathname;
    if (
      !event.defaultPrevented &&
      !isCredentialBearingPath(pathname) &&
      isInitialized &&
      cookieManager.isAllowed('analytics')
    ) {
      window.posthog?.capture('app_store_click', {
        destination_platform: platform,
        placement,
        page_path: sanitizeAnalyticsPathname(pathname),
      });
    }
  }

  return (
    <a
      {...anchorProps}
      href={`${downloadPaths[platform]}?source=${encodeURIComponent(placement)}`}
      onClick={handleClick}
    >
      {children}
    </a>
  );
}
